import api from './api';

class User {
  private opts: any;

  /**
   * @param {Object|null} opts
   * @param {String} opts.username
   * @param {String[]} opts.roles
   * @param {String[]} opts.accesses
   */
  constructor(opts: Object | null) {
    this.opts = opts || {};
  }

  hasRole(role: string): boolean {
    if (!this.opts.roles) {
      return false;
    }
    return this.opts.roles.indexOf(role) > -1;
  }

  hasAccess(access: string): boolean {
    if (!this.opts.accesses) {
      return false;
    }
    return this.opts.accesses.indexOf(access) > -1;
  }

  hasSignature(): boolean {
    if (!this.opts.eds || !this.opts.eds.has_signature) {
      return false;
    }
    return !!this.opts.eds.has_signature;
  }

  hasOpts(): boolean {
    return this?.opts?.id > 0
  }

  getLang(): string {
    return this.opts?.lang ?? 'en'
  }
}

class Config {
  private params: object;

  /**
   * Настройки приложения.
   *
   * @param {Object|null} settings, appBar: classic|modern.
   */
  private settings = {
    appBar: 'modern',
  };

  public reload(): Promise<any> {
    return api.get('/initialize', {}).then((params) => {
      this.params = params;
      return params;
    });
  }

  public get(name: string): any {
    return this.params[name];
  }

  public set(name: string, value) {
    return (this.params[name] = value);
  }

  public getUser(): User {
    return new User(this.get('user'));
  }

  public isGuest(): boolean {
    return !this.getUser()?.hasOpts();
  }

  public getConfig(code) {
    return this.get('systemConfig')[code];
  }

  public getSettings(): object {
    return this.settings;
  }
}

export default new Config();
